import { FC, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useT } from '_metronic/i18n/Metronici18n'
import { FormInput, FormTextArea, useModal, useToast } from 'app/components'
import { trataErroDoModal } from '../../../dispositivos/core/errosFormulario'
import { textoOuNulo } from '../../../dispositivos/core/textoOuNulo'
import { camposDicomSchema } from '../../../dispositivos/components/modal/validation/dispositivoSchema'
import { TelekitDispositivoList } from '../../telekits-list/core/_models'
import { editarAlocacao } from '../../telekits-list/core/_requests'
import { ErrosGerais } from '../../../dispositivos/core/ErrosGerais'
import { RodapeModal } from '../../../dispositivos/core/RodapeModal'

const CAMPOS = ['aeTitle', 'modalidade', 'descricao', 'observacao'] as const
export const EditarAlocacaoModal: FC<{ idTelekit: number; alocacao: TelekitDispositivoList }> = ({
  idTelekit,
  alocacao,
}) => {
  const { closeModal } = useModal()
  const { showToast } = useToast()
  const { t } = useT()
  const [erroGeral, setErroGeral] = useState<string[]>([])

  const formik = useFormik({
    initialValues: {
      aeTitle: alocacao.aeTitle ?? '',
      modalidade: alocacao.modalidade ?? '',
      descricao: alocacao.descricao ?? '',
      observacao: alocacao.observacao ?? '',
    },
    validationSchema: Yup.object().shape({
      ...camposDicomSchema(t),
    }),
    onSubmit: async (valores, helpers) => {
      setErroGeral([])
      try {
        await editarAlocacao(idTelekit, alocacao.id, {
          aeTitle: textoOuNulo(valores.aeTitle),
          modalidade: textoOuNulo(valores.modalidade),
          descricao: textoOuNulo(valores.descricao),
          observacao: textoOuNulo(valores.observacao),
        })
        showToast({ variant: 'success', title: t('pagina.telekits.dispositivos.alocacao_salva') })
        closeModal()
      } catch (error) {
        trataErroDoModal(error, helpers, CAMPOS, setErroGeral)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <ErrosGerais erros={erroGeral} />
      <div className='row g-4 mb-5'>
        <div className='col-md-6'>
          <FormInput
            formik={formik}
            name='aeTitle'
            label={t('pagina.telekits.dispositivos.campo.ae_title')}
          />
        </div>
        <div className='col-md-6'>
          <FormInput
            formik={formik}
            name='modalidade'
            label={t('pagina.telekits.dispositivos.campo.modalidade')}
          />
        </div>
      </div>
      <div className='mb-5'>
        <FormInput
          formik={formik}
          name='descricao'
          label={t('pagina.telekits.dispositivos.campo.descricao')}
        />
      </div>
      <FormTextArea
        formik={formik}
        name='observacao'
        label={t('pagina.telekits.dispositivos.campo.observacao')}
        rows={3}
      />
      <RodapeModal enviando={formik.isSubmitting} rotuloEnviar={t('common.save')} />
    </form>
  )
}
